import React, { useCallback } from 'react'

import { Dialog, DialogContent } from '@/components/common/Dialog'

interface AnnouncementModalProps {
  open: boolean
  onDismiss: () => void
  children: React.ReactNode
}

/**
 * Presentational shell for a single announcement. Owns nothing but the dialog
 * chrome (the single built-in close button, sizing, dismiss-on-backdrop); the
 * body content decides everything inside.
 */
export const AnnouncementModal: React.FC<AnnouncementModalProps> = ({
  open,
  onDismiss,
  children,
}) => {
  const handleOpenChange = useCallback(
    (nextOpen: boolean) => {
      if (!nextOpen) onDismiss()
    },
    [onDismiss],
  )

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        aria-describedby={undefined}
        className="max-w-[480px] overflow-hidden p-0"
        closeButtonClassName="top-4 right-4 z-20 rounded-lg bg-black/5 hover:bg-black/10 dark:bg-white/5 dark:hover:bg-white/10"
      >
        {children}
      </DialogContent>
    </Dialog>
  )
}
